/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'posts': {
    width: 20,
    height: 14,
    viewBox: '0 0 20 14',
    data: '<path pid="0" d="M18.9 0a.7.7 0 0 1 .7.7v12.6a.7.7 0 0 1-.7.7H.7a.7.7 0 0 1-.7-.7V.7A.7.7 0 0 1 .7 0h18.2zm-.233.933H.933v12.134h17.734V.933zM8.334 5.6c.085 0 .154.069.154.154v5.226a.154.154 0 0 1-.154.154h-5.38a.154.154 0 0 1-.154-.154V5.754c0-.085.069-.154.154-.154h5.38zm8.058 3.733c.225 0 .408.224.408.5 0 .246-.144.45-.335.492l-.073.008h-5.717c-.226 0-.408-.224-.408-.5 0-.245.144-.45.335-.492l.073-.008h5.717zm-8.838-2.8H3.733V10.2h3.82V6.533zm8.838 0c.225 0 .408.224.408.5 0 .246-.144.45-.335.492l-.073.008h-5.717c-.226 0-.408-.224-.408-.5 0-.245.144-.45.335-.492l.073-.008h5.717zM16.36 2.8c.243 0 .44.224.44.5 0 .245-.156.45-.36.492l-.08.008H3.24c-.243 0-.44-.224-.44-.5 0-.245.156-.45.36-.492l.08-.008h13.12z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/posts.js